<template>
  <div class="infoDiv-view">
    <div class="top-cont-text">
      <div class="left">单位全称：</div>
      <div class="right">
        {{ params.fullName || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">单位简称：</div>
      <div class="right">
        {{ params.shortName || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">统一社会信用代码：</div>
      <div class="right">
        {{ params.creditCode || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">营业执照扫描件：</div>
      <div class="right">
        <img
          class="card-img"
          :src="params.fileUrl"
          @click="preview_img([params.fileUrl], 0)"
          v-if="params.fileUrl"
        />
        <span v-else>--</span>
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">企业规模：</div>
      <div class="right">
        {{ params.scale || "--" }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">经营范围：</div>
      <div class="right">
        {{ params.scope }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">主要联系人：</div>
      <div class="right">
        {{ params.name }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">手机号码：</div>
      <div class="right">
        {{ params.phone }}
      </div>
    </div>
    <div class="top-cont-text">
      <div class="left">身份证号码：</div>
      <div class="right">
        {{ params.cardNum }}
      </div>
    </div>

    <div style="height: 130px;"></div>
    <div class="footer-cont2" style="background: #fff;">
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="
          $router.push({
            path: 'rhwxInfoModify',
            query: {
              type: 'edit'
            }
          })
        "
        >修改</van-button
      >
      <van-button
        type="primary"
        block
        class="btnStyle2"
        @click="
          $router.push({
            path: 'rhwxWelcome'
          })
        "
        >返回</van-button
      >
    </div>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      params: {
        id: "",
        fullName: "", // 全称
        shortName: "", // 简称
        creditCode: "", // 统一社会信用代码
        fileObj: {}, // 文件
        fileUrl: "",
        file: [],
        scale: "", // 经营规模
        scope: "", // 经营范围
        name: "", // 主要联系人
        cardNum: "", // 身份证号
        phone: "" // 手机号
      },
      columnScale: [
        "1-30人",
        "31-50人",
        "51-100人",
        "101-200人",
        "201-500人",
        "501-1000人",
        "1001及以上"
      ],
      rowDataObj: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    preview_img(images, index) {
      ImagePreview({
        images: images, // 图片数组
        showIndex: false,
        loop: false,
        startPosition: index
        // closeable: true
      });
    },

    // 获取单位详情
    async getDetail() {
      await this.$common
        .http({
          url: "/api/supplier/unit_detail"
        })
        .then(res => {
          console.log(res);
          this.rowDataObj = res.data.data;
          this.params.id = this.rowDataObj.id;
          this.params.fullName = this.rowDataObj.full_name;
          this.params.shortName = this.rowDataObj.short_name;
          this.params.creditCode = this.rowDataObj.unified_social_credit_code;
          this.params.fileObj = this.rowDataObj.files[0];
          this.params.scale =
            this.rowDataObj.unit_size === 0
              ? ""
              : this.columnScale[this.rowDataObj.unit_size - 1];
          this.params.scope = this.rowDataObj.business_scope;
          this.params.name = this.rowDataObj.contact;
          this.params.cardNum = this.rowDataObj.id_card;
          this.params.phone = this.rowDataObj.phone;

          if (this.rowDataObj.files.length > 0) {
            this.params.fileUrl = this.rowDataObj.files[0].real_path;
          }
        });
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.infoDiv-view {
  background: #fff;
  font-size: 16px;
  padding-top: 20px;
  .top-cont-text {
    padding: 0px 16px 18px;
    display: flex;
    .left {
      // display: inline-block;
      // width: calc(45vw - 12px);
      text-align: right;
      margin-right: 21px;
      vertical-align: top;
      color: #999;
      flex: 1;
    }
    .right {
      // display: inline-block;
      // width: calc(54vw - 32px);
      vertical-align: top;
      word-break: break-all;
      flex: 1.1;
    }
  }
  .card-img {
    object-fit: cover;
    width: 60px;
    height: 60px;
    // height: calc((100vw - 42px) / 2.5);
    // width: calc((100vw - 42px) / 3.4);
  }
}
</style>
